export default __webpack_public_path__ + "static/media/ROME.c45a08ae.png";